import {ScreenTransitionController} from "../base/ScreenTransitionController";

// Path to Mars screen transitions. The background morph is fired directly (not
// through the controller timeline) so it starts the instant goToScreen is called.
export class PathToMarsScreenTransition extends ScreenTransitionController {

  constructor(morpher) {
    super();
    this.morpher = morpher;
  }

  // Choose the shape for the target screen
  shapeForScreen(screenId) {
    const targetScreenNoSuffix = parseInt(screenId.toString().split("-")[0]);
    return targetScreenNoSuffix === 1 ? "rect" : "blob";
  }
}
